module.exports = __webpack_public_path__ + "img/m-banner-tcawxgez-th-TH.d3ab8274.jpg";